// extracted by mini-css-extract-plugin
export var notificationHost = "_kq-0";